import { Button, Stack, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { CheckOutIllustration } from "assets";
import type { EventTaskTab } from "./CalendarTasksTabs";

type CalendarTasksNotFoundProps = {
  currentTab: EventTaskTab;
  inListingMatch?: boolean;
  overdueEventsCount: number;
  onMoveAllOverdueTasksToToday: () => Promise<void>;
};

export function CalendarTasksNotFound({
  currentTab,
  inListingMatch,
  overdueEventsCount,
  onMoveAllOverdueTasksToToday
}: CalendarTasksNotFoundProps): JSX.Element {
  const { t: translate } = useTranslation();

  const notTaskFoundContent = (
    <Typography variant="h6" color="text.secondary">
      {translate(
        currentTab === "assignedByMe" ? "calendarPage.officeTasks.noneAssigned" : "calendarPage.tasks.noTasksFound"
      )}
    </Typography>
  );

  if (inListingMatch) {
    return <Stack alignItems="center">{notTaskFoundContent}</Stack>;
  }

  const showMoveAllOverdueTasksToTodayButton = currentTab === "today" && !!overdueEventsCount;

  return (
    <Stack sx={{ height: 384 }} justifyContent="center">
      <Stack
        sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}
        gap={2}
        alignItems="center"
      >
        <CheckOutIllustration
          sx={{
            display: "grid",
            maxWidth: 300,
            maxHeight: 180
          }}
        />
        {notTaskFoundContent}
        {showMoveAllOverdueTasksToTodayButton && (
          <Button
            size="small"
            color="primary"
            variant="contained"
            onClick={onMoveAllOverdueTasksToToday}
          >
            {translate("calendarPage.control.moveOverdueTasksToToday")}
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
